import { Box, Paper, Stack, Typography } from '@mui/material';
import HorizontalLogo from 'components/horizontal-logo/horizontal-logo.component';

const StandalonePage = ({ title, description, children, ...rest }) => {
  return (
    <Box
      display="flex"
      flex={1}
      flexDirection={{ xs: 'column', md: 'row' }}
      {...rest}
    >
      <Box
        component={Paper}
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        flex={{ md: 1 }}
        borderRadius={0}
        p={{ xs: 2, lg: 6 }}
      >
        <Stack
          display="flex"
          direction={{ xs: 'row', md: 'column' }}
          alignItems="center"
          justifyContent="center"
          mb={2}
          spacing={{ xs: 2, md: 0 }}
        >
          <HorizontalLogo />
          <Typography component="h1" variant="h4">
            {title}
          </Typography>
        </Stack>
        {description && <Typography variant="body1">{description}</Typography>}
      </Box>
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        padding={{ xs: 3, lg: 2 }}
        width={{ xs: '100%', md: '50%', lg: 600, xl: 960 }}
        flex={{ xs: 1, md: 'unset' }}
      >
        {children}
      </Box>
    </Box>
  );
};

export default StandalonePage;
